import script from "./DevView.vue?vue&type=script&lang=ts&setup=true"
export * from "./DevView.vue?vue&type=script&lang=ts&setup=true"

import "./DevView.vue?vue&type=style&index=0&id=27eba22d&scoped=true&lang=less"

import exportComponent from "/home/gibo/development/primakurzyonline.cz-screencast/trunk/lector-code/pko-lector-code-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27eba22d"]])

export default __exports__